/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CampaignSequenceDto } from '../models/CampaignSequenceDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CampaignSequenceControllerService {
    /**
     * @param uuid
     * @returns CampaignSequenceDto OK
     * @throws ApiError
     */
    public static getCampaignSequenceByUuid(
        uuid: string,
    ): CancelablePromise<CampaignSequenceDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/campaign-sequences/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static updateCampaignSequence(
        uuid: string,
        requestBody: CampaignSequenceDto,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/campaign-sequences/{uuid}',
            path: {
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns any OK
     * @throws ApiError
     */
    public static deleteCampaignSequence(
        uuid: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/campaign-sequences/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @returns CampaignSequenceDto OK
     * @throws ApiError
     */
    public static getAllCampaignSequences(): CancelablePromise<Array<CampaignSequenceDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/campaign-sequences',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static createCampaignSequence(
        requestBody: CampaignSequenceDto,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/campaign-sequences',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns CampaignSequenceDto OK
     * @throws ApiError
     */
    public static addMissingProducts(
        uuid: string,
    ): CancelablePromise<CampaignSequenceDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/campaign-sequences/{uuid}/add-missing-products',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param dayOfWeek
     * @returns CampaignSequenceDto OK
     * @throws ApiError
     */
    public static getCampaignSequenceByDayOfWeek(
        dayOfWeek: string,
    ): CancelablePromise<CampaignSequenceDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/campaign-sequences/by-day-of-week',
            query: {
                'dayOfWeek': dayOfWeek,
            },
        });
    }
    /**
     * @param dayOfWeek
     * @returns CampaignSequenceDto OK
     * @throws ApiError
     */
    public static getCampaignSequencesByDayOfWeek(
        dayOfWeek: string,
    ): CancelablePromise<Array<CampaignSequenceDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/campaign-sequences/by-day-of-week/list',
            query: {
                'dayOfWeek': dayOfWeek,
            },
        });
    }
}
